import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import { SPACE_RESTRICTED_PAGES, ADMIN_AUDIT_LOG } from '@confluence/named-routes';
import { RoutesContext } from '@confluence/route-manager/entry-points/RoutesContext';

import { ChangeEditionSectionMessageAuditLogs } from '../SectionMessage/ChangeEditionSectionMessageAuditLogs';
import { ChangeEditionSectionMessageSpaceContent } from '../SectionMessage/ChangeEditionSectionMessageSpaceContent';

export const FREE_SECTION_MESSAGE_COMPONENT_PLACEHOLDER_ID =
	'confluence-change-edition-section-message';
export class ChangeEditionSectionMessageLegacyCoordinator extends Component {
	el = window.document.getElementById(FREE_SECTION_MESSAGE_COMPONENT_PLACEHOLDER_ID);

	ROUTE_NAME2COMPONENT = {
		[SPACE_RESTRICTED_PAGES.name]: ChangeEditionSectionMessageSpaceContent,
		[ADMIN_AUDIT_LOG.name]: ChangeEditionSectionMessageAuditLogs,
	};

	isSectionMessageNeeded(routeName) {
		return routeName && Boolean(this.ROUTE_NAME2COMPONENT[routeName.name]);
	}

	getComponentParams(routeName) {
		if (routeName === SPACE_RESTRICTED_PAGES.name) {
			return {
				grandfathered: this.el.getAttribute('data-grandfathered') === 'true',
			};
		}

		return {};
	}

	render() {
		if (!this.el) {
			return null;
		}

		return (
			<RoutesContext.Consumer>
				{({ location, matchRoute }) => {
					const routeName = matchRoute(location.pathname + location.search);

					if (!this.isSectionMessageNeeded(routeName)) {
						return null;
					}

					const ChangEditionComponent = this.ROUTE_NAME2COMPONENT[routeName.name];

					return ReactDOM.createPortal(
						<ChangEditionComponent {...this.getComponentParams(routeName.name)} />,
						this.el,
					);
				}}
			</RoutesContext.Consumer>
		);
	}
}
